<template>
  <div class="table-template">
    <h3>Your Connected TA Consultants</h3>
    <data-table
        table-id="connected-programs-table"
        :items="consultants"
        :fields="fields"
        :empty-text="emptyText"
        :loading="loading"
    >
      <template #connected="{item}">
        {{ formatConnectedDate(item.pivot) }}
      </template>
    </data-table>
    <hr class="info-wrapper-separator" />
  </div>
</template>

<script>
  import DataTable from '../DataTable.vue';

export default {

  components: {
    DataTable
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "email",
          label: "E-mail",
        },
        {
          key: "connected",
          label: "Connected",
        },
      ],
    };
  },
  props: {
    consultants: {
      required: true,
    },
  },
  methods: {
    formatConnectedDate(pivot) {
      if (pivot && pivot.created_at) {
        return window.moment(pivot.created_at).format("YYYY-MM-DD");
      }
    },
  },
  computed: {
    emptyText: function() {
      return "No connected TA consultants";
    },
    loading: function() {
      return false;
    },
  }
};
</script>
